import React, { useRef } from "react";
import { findDOMNode } from "react-dom";
import PropTypes from "prop-types";

function ContentEditable({
  id,
  className,
  tag = "div",
  onChange,
  placeholder = "Type here...",
  style = {fontSize:'16px'},
  html,
}) {
  const contentEditable = useRef(null);
  const emitChange = () => {
    var html = findDOMNode(contentEditable.current).innerText;
    if (onChange) {
      onChange({
        target: {
          value: html,
        },
      });
    }
  };
  const HtmlTag = tag;
  return (
    <HtmlTag
      id={id}
      className={className}
      ref={contentEditable}
      onInput={emitChange}
      contentEditable={true}
      placeholder={placeholder}
      style={style}
      dangerouslySetInnerHTML={{ __html: html }}
    ></HtmlTag>
  );
}

ContentEditable.propTypes = {
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  html: PropTypes.string.isRequired,
};

export default React.memo(ContentEditable);
